module.exports = __webpack_public_path__ + "media/app/assets/specializations/priest/holy-ee8d4d39660f7878ca9f0e4d4311e4d2.png";